export default __webpack_public_path__ + "static/media/plant_corner.2e56fd1e.jpg";